<template>
  <dol-select :value="value" source="local" :default-data="options" @update:value="change" >
    <template #option="{option}">
      <dol-icon :type="option.code" /> {{option.text}}
    </template>
  </dol-select>
</template>

<script>
import * as AntIcons from '@ant-design/icons-vue';
export default {
  name: "dol-icon-select",
  props: {
    value: {type: String},
    iconType: {type: String, default: 'Filled|Outlined|TwoTone'},
  },
  data(){
    let options = [];
    Object.keys(AntIcons).forEach(key => new RegExp(`(${this.iconType})$`).test(key) && options.push({text: key, code: key}));
    return {
      options,
    }
  },
  methods: {
    change(value){
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss">
.dol-icon-select {

}
</style>
